export default {
  en: {    
  	fleet: {
  		search: 'Search a vehicle',
      add: 'Add a new vehicle',
      edit: 'Edit the vehicle of {name}',
      addbtn: 'Add',
      notavailable: 'No vehicles available',
      notavailabledisclaimer: 'You don’t have any vehicles yet. Add one.',
      transport_license_needed: 'Transport license required!',
      licenseplate: 'License plate',
      cartype: 'Car type',
      loadingcapacity: 'Loading capacity',
      driver: 'Driver',
      editbtn: 'Edit',      
      createdisclaimer: 'The driver can log in to the Vengo-app (available for Android and IOS) with the provided e-mailadress and password. This adress will not be used for e-mailing so it does not have to be an existing one. With the app, he or she can easily update the status of the shipment. Another alternative is to manually complete the shipments and upload a proof of delivery.',
      isactive: 'This driver is currently delivering a shipment. You cannot adjust his data at this moment',
      transportlicenserequired: 'To deploy vehicles with a loading capacity over 500kg or more, we ask for a valid transportation permit. Upload one in your profile and/or wait for approval of our staff members'
  	}  	
  },
  nl: {    
  	fleet: {
  		search: 'Zoek een voertuig',
      addbtn: 'Toevoegen',
      add: 'Voeg een nieuw voertuig toe',
      edit: 'Pas het voertuig van {name} aan',
      notavailable: 'Geen voertuigen beschikbaar',
      notavailabledisclaimer: 'Je hebt nog geen voertuigen. Voeg er een toe.',
      licenseplate: 'Nummerplaat',
      transport_license_needed: 'Transportvergunning nodig!',
      cartype: 'Voertuigtype',
      loadingcapacity: 'Laadvermogen',
      driver: 'Chauffeur',
      editbtn: 'Pas aan',
      createdisclaimer: 'De chauffeur kan inloggen in de Vengo-app (beschikbaar voor Android en iOS) met het opgegeven e-mailadres en wachtwoord. Dit adres wordt niet gebruikt voor mails dus het moet niet bestaan. Met de app kan hij of zij de status van de zending eenvoudig updaten. Het alternatief is dat u de zendingen zelf handmatig afwerkt en een leverbewijs uploadt.',
      isactive: 'Deze chauffeur voert momenteel een zending uit. Je kan zijn gegevens daarom nu niet aanpassen.',
      transportlicenserequired: 'Om voertuigen met een laadvermogen van 500 kg of meer in te zetten, vragen wij om een geldige transportvergunning. Upload er een in je profiel en/of wacht op goedkeuring van onze medewerkers.'      
  	}  	  	
  },
  fr: { 
  	fleet: {
      search: 'Trouver un véhicule',
      addbtn: 'Ajouter',
      add: 'ajoute un véhicule',
      edit: 'édite le véhicule de {name}',
      notavailable: 'Aucun véhicule disponible',
      notavailabledisclaimer: 'Vous n’avez pas encore de véhicules. Ajoutez-en un.',
      licenseplate: 'Plaque d’immatriculation',
      transport_license_needed: 'Besoin d’un permis de transport!',
      cartype: 'Type de véhicule',
      loadingcapacity: 'Charge utile',
      driver: 'Chauffeur',
      editbtn: 'Ajuster',
      createdisclaimer: 'Le chauffeur peut se connecter à l’application Vengo (disponible pour Android et IOS) avec l’adresse e-mail et mot de passe spécifié. Cette adresse n’est pas utilisée pour les courriels, elle ne devrait donc pas exister. Avec l’application, le chauffeur peut mettre à jour le statut de l’envoi. L’alternative est que vous finissiez les envois manuellement, et que vous téléchargez un bon de livraison.',
      isactive: 'Ce chauffeur est en train d’effectuer un envoi. Vous ne pouvez pas ajuster ces données maintenant',
      transportlicenserequired: 'Pour utiliser des véhicules avec une charge utile de 500 kg ou plus, nous demandons un permit de transport. Téléchargez une dans votre profil et/ou attend l’approbation de nos employés.'
  	}  	     
  }
}
